import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {AppComponent} from './app.component';
import {SharedModule} from './common/shared.module';
import {AuthGuard} from './guards/auth.guard';
import {ROUTES} from './app.routes';
import {NoPreloading, RouterModule} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {CommonModule} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ClientService} from './services/client.service';
import {SessionService} from './services/session.service';
import {ComponentModule} from "./common/component.module";
import {SharingService} from "./services/sharing.service";
import {DlgChangePasswordComponent} from "./login/DlgChangePasswordComponent";
import {DlgAskOTP} from "./common/DlgAskOTP";
import {TraceService} from "./services/trace.service";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {UIService} from "./services/ui.service";
import {ZohoService} from "./services/zoho.service";
import {DlgUpdateEmailComponent} from "./login/DlgUpdateEmailComponent";
import {DlgChooseDate} from "./common/DlgChooseDate";
import {PopupServices} from "./services/popup.services";
import {HttpClientModule} from "@angular/common/http";
import {ChatService} from "./services/chat.service";
import {TokenServices} from "./services/token.service";

@NgModule({
  declarations: [
    AppComponent,
    DlgAskOTP,
    DlgChangePasswordComponent,
    DlgChooseDate,
    DlgUpdateEmailComponent,
    LoginComponent
  ],
  entryComponents:[
    DlgAskOTP,
    DlgChangePasswordComponent,
    DlgChooseDate,
    DlgUpdateEmailComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    ComponentModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    // RouterModule.forRoot(ROUTES, { useHash: true, preloadingStrategy: NoPreloading }),
    RouterModule.forRoot(ROUTES, { useHash: false, preloadingStrategy: NoPreloading }),
    SharedModule
  ],

  providers: [AuthGuard, ClientService,ChatService,PopupServices, SessionService,SharingService,TokenServices,TraceService,UIService,ZohoService
    /*{
      provide: APP_BASE_HREF,
      useValue:'/' + (window.location.pathname.split('/')[1] || '')
    } */

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

